import { GetterTree } from 'vuex';
import { State } from '@/store/modules/cloud/detail/detail.store';

const getters: GetterTree<State, any> = {
  getCurrentServiceInstance(state: State): any {
    return state.currentServiceInstance;
  },
  getCurrentServices(state: State): any {
    return state.currentServices;
  },
  getCurrentTab(state: State): any {
    return state.currentTab;
  },
  getCurrentService(state: State): any {
    return state.currentService;
  },
};

export default getters;
